"use client";
import { jsx as m } from "react/jsx-runtime";
import { createContext as F, useContext as u } from "react";
import { useChatForm as c } from "./chat-form-provider.js";
const e = F(void 0), a = ({ children: r, field: o, fieldProps: t, autoFocus: n }) => {
  const { errors: i } = c(), s = i[o.name];
  return /* @__PURE__ */ m(e.Provider, { value: { field: o, fieldProps: t, error: s, autoFocus: n }, children: r });
}, v = () => {
  const r = u(e);
  if (!r)
    throw new Error("useFormField must be used within a FormFieldProvider");
  return r;
};
export {
  a as FormFieldProvider,
  v as useFormField
};
